const fileTypes = {
  spreadsheet: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.oasis.opendocument.spreadsheet'
  ],

  document: [
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],

  image: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png', 'image/webp'],

  video: [
    'video/mp4',
    'application/x-mpegURL',
    'video/quicktime',
    'video/x-ms-wmv',
    'video/webm',
    'video/x-msvideo',
    'video/mpeg'
  ],

  csv: ['text/csv'],

  pdf: ['application/pdf']
}

export const fileExtensions = {
  spreadsheet: ['xls'],

  document: ['doc', 'docx'],

  image: ['jpg', 'jpeg', 'png', 'gif', 'webp'],

  csv: ['csv'],

  pdf: ['pdf'],

  video: ['mp4', 'mov', 'webm', 'mpeg', 'm4v', 'qt', 'flv', 'ogg', 'avi', 'wmv']
}

export const mimeTypesToExtension = {
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpeg',
  'image/gif': 'gif',
  'image/png': 'png',
  'image/webp': 'webp',
  'video/mp4': 'mp4',
  'application/x-mpegURL': 'm3u8',
  'video/quicktime': 'mov',
  'video/x-ms-wmv': 'wmv',
  'video/webm': 'webm',
  'video/x-msvideo': 'avi',
  'video/mpeg': 'mpeg',
  'text/csv': 'csv',
  'application/pdf': 'pdf'
}

export function getMimeTypeFromExtension(extension) {
  for (const [mimeType, ext] of Object.entries(mimeTypesToExtension)) {
    if (ext === extension) {
      return mimeType
    }
  }
  return null
}

export default fileTypes
